module.exports = __webpack_public_path__ + "img/icon14.2216b1e1.2216b1e1.svg";